import { EUserLoanFlow } from "../loans/enum"

export enum EEarningStatuses {
  NEW = 'NEW',
  CONFIRMED = 'CONFIRMED',
  CANCELLED = 'CANCELLED',
  DEPOSITING = 'DEPOSITING',
  ACTIVE = 'ACTIVE',
  INCREASING = 'INCREASING',
  CHARGING = 'CHARGING',
  WAITING_WITHDRAW = 'WAITING_WITHDRAW',
  WITHDRAWING = 'WITHDRAWING',
  CLOSED = 'CLOSED',
  FAILED = 'FAILED',
  FAILED_BY_PARTNER = 'FAILED_BY_PARTNER',
}

export enum EProcessingTxStatuses {
  NEW = 'new',
  WAITING = 'waiting',
  CONFIRMING = 'confirming',
  EXCHANGING = 'exchanging',
  SENDING = 'sending',
  FINISHED = 'finished',
  FAILED = 'failed',
  REFUNDED = 'refunded',
  EXPIRED = 'expired',
}

export interface IFormattedTxInfo {
  amount: string
  hash: string
  timestamp: Date
  status: string
  incoming: boolean
  id?: string
}

export enum EBlockchainTxStatuses {
  BUILDING = 'BUILDING',
  SENT = 'SENT',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  PLEDGE_TRANSACTION_SENT = 'PLEDGE_TRANSACTION_SENT',
  WITHDRAW_SENT = 'WITHDRAW_SENT',
  CANCELED = 'CANCELED',
}

export interface IFormattedEarning {
  earn_id: string
  currency_code: string
  currency_network: string
  earns: string
  total_earns: string
  status: EEarningStatuses
  deposit: {
    expected_amount: string
    amount: string
    transaction_status: EProcessingTxStatuses
    transaction_hash: string
    send_address: string
    send_extra_id: string
    active: boolean
    payin_tx: IFormattedTxInfo
  }
  increase: {
    expected_amount: string
    amount: string
    transaction_status: EProcessingTxStatuses
    transaction_hash: string
    send_address: string
    send_extra_id: string
    active: boolean
    payin_txs: IFormattedTxInfo[]
    transaction_id: string
    flow?: EUserLoanFlow
    created_at?: string
  }
  withdraw: {
    available_amount: string
    amount: string
    address: string
    extra_id: string
    transaction_status: EBlockchainTxStatuses
    transaction_hash: string
    payout_txs: IFormattedTxInfo[]
    event_id?: string
    transaction_id?: string
  }
  percents: {
    annual: string
  }
  user: {
    phone: string
    email: string
  }
  receive_from?: string
  created_at: string // ISO string
  updated_at: string // ISO string
  closed_at: string // ISO string
}

export enum EEarnEventTypes {
  DEPOSIT = 'DEPOSIT',
  INCREASE = 'INCREASE',
  WITHDRAW = 'WITHDRAW',
  CHARGING = 'CHARGING',
  EARN_VERIFYING = 'EARN_VERIFYING',
  WITHDRAW_VERIFYING = 'WITHDRAW_VERIFYING',
  ANNUAL_PERCENT_CHANGE = 'ANNUAL_PERCENT_CHANGE',
}

export enum EEarnEventStatuses {
  PROCESSING = 'PROCESSING',
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS',
  CANCELED = 'CANCELED',

  FINISHED = 'finished',
  WAITING = 'waiting',
}

type EEarnReceiveTo = 'external_wallet' | 'internal_wallet'

export interface IFormattedEarnEvent {
  id: string
  type: EEarnEventTypes
  status: EEarnEventStatuses
  amount: string
  hash?: string
  updated_at: number
  created_at: number
  receive_withdraw_to: EEarnReceiveTo
}

export interface ITotalAmountOfSavings {
  count: number
  depositAmountReducedInUsd: string
  pendingAmountReducedInUsd: string
  groups: [
    {
      amount: string
      code: string
      network: string
      pendingAmount: string
    },
  ]
}

export const EEarnAPY = {
  PERCENT: 5,
}

export enum FormattedSavingStatus {
  PENDING = 'Pending',
  CANCELED = 'Canceled',
  PROCESSING = 'Processing',
  ACTIVE = 'Active',
  CLOSED = 'Closed',
}

export interface EarnWithdrawEstimateResponse {
  fee: string
}

export interface EarnWithdrawEstimateDto {
  code: string
  network: string
  amount: string
}